var swal = require('sweetalert2');

module.exports = function () {
    $(document).ready(function (event) {

        var helper = require('./helper');
        var AjaxController = require('./services/AjaxController');

        var oldValue = $('.js-budget-update-field').val();

        $(document).on('change', '.js-budget-update-field', function(e){

            var $this = $(this);
            var budgetId = $this.data('id'),
                field = $this.data('field'),
                value = $this.val();
            var url = '/api/budgets/change-field';

            var data = {
                field: field,
                budgetId: budgetId,
                value: value
            };
            var success = function (response) {
                console.log('Success');
            }
            var error = function (response) {
                //console.log('Error');
            }

            e.preventDefault();

            swal({
                title: "Are you sure you want to save notes?",
                text: "",
                type: "warning",
                showCancelButton: true
            }).
            then(function (result) {
                if (result.value) {
                    AjaxController.prototype.send(url, data, success, error);
                    $("#edited-budget-notes").load(location.href + " #edited-budget-notes>*", "");

                    oldValue = $(".js-budget-update-field").val();
                } else {
                    $(".js-budget-update-field").val(oldValue);
                }
            })
        });

        $(document).on('click', '.js-budget-update-amount', function(e){

            var $this = $(this);
            var budgetId = $this.data('id');
            var field = $this.data('field');
            var url = '/api/budgets/change-field';

            var data = {
                budgetId: budgetId,
                field: field,
                value: "",
            };
            var success = function (response) {
                var amount = response['amount'];
                $this.html('<b>£ '+ amount +' </b><span class="badge badge-primary" style="margin-left:10px;padding-left: 6px; cursor: pointer;"> edit </span>');
                $('#'+budgetId+'-remaining').text('£' + response['remaining'] );
            }
            var error = function () {
            }

            e.preventDefault();

            swal({
                title: "New amount for budget",
                input: 'text',
                type: "warning",
                showCancelButton: true
            }).
            then(function (result) {
                if (result.value) {
                    data['value'] = result.value;

                    AjaxController.prototype.send(url, data, success, error);
                }
            })
        });
    });
}();
